let ss_fun_tas_sel_isDown = false;
let startX;
let scrollLeft;
let ss_fun_tas_sel_moved = false;

document.querySelectorAll(".fnt_tsm_cllc_list")[0].addEventListener('mousedown', (e) => {
  ss_fun_tas_sel_isDown = true;
  ss_fun_tas_sel_moved = false;
  startX = e.pageX - document.querySelectorAll(".fnt_tsm_cllc_list")[0].offsetLeft;
  scrollLeft = document.querySelectorAll(".fnt_tsm_cllc_list")[0].scrollLeft;
});

document.querySelectorAll(".fnt_tsm_cllc_list")[0].addEventListener('mouseup', () => {
  ss_fun_tas_sel_isDown = false;
});

document.querySelectorAll(".fnt_tsm_cllc_list")[0].addEventListener('mouseleave', () => {
  ss_fun_tas_sel_isDown = false;
});

document.querySelectorAll(".fnt_tsm_cllc_list")[0].addEventListener('mousemove', (e) => {
  if (!ss_fun_tas_sel_isDown) return;
  e.preventDefault();

  const x = e.pageX - document.querySelectorAll(".fnt_tsm_cllc_list")[0].offsetLeft;
  const walk = x - startX;

  if (Math.abs(walk) > 5) ss_fun_tas_sel_moved = true;

  document.querySelectorAll(".fnt_tsm_cllc_list")[0].scrollLeft = scrollLeft - walk;
});

document.querySelectorAll(".fnt_tsm_cllc_list")[0].querySelectorAll('a').forEach(fnt_tsm_cllc_a => {
  fnt_tsm_cllc_a.addEventListener('click', (e) => {
    if (ss_fun_tas_sel_moved){
        e.preventDefault();
    };
  });
});

document.addEventListener('mouseup', () => {
  ss_fun_tas_sel_isDown = false;
});


document.querySelectorAll('.cstm_cllcL_main-btn_cnt.cstclsb_R')[0].addEventListener('click', () => {
    var slider = document.querySelectorAll(".fnt_tsm_cllc_list")[0];
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    if(window.innerWidth > 641){
      var step = window.innerWidth * 0.2;
    }else{
      var step = window.innerWidth * 0.5;
      console.log(step);
    };
    slider.scrollTo({
      left: Math.min(slider.scrollLeft + step, maxScroll),
      behavior: 'smooth'
    });
    /*slider.scrollLeft = Math.min(slider.scrollLeft + 200, maxScroll);*/
});

document.querySelectorAll('.cstm_cllcL_main-btn_cnt.cstclsb_L')[0].addEventListener('click', () => {
    var slider = document.querySelectorAll(".fnt_tsm_cllc_list")[0];
    if(window.innerWidth > 641){
      var step = window.innerWidth * 0.2;
    }else{
      var step = window.innerWidth * 0.5;
      console.log(step);
    };
    slider.scrollTo({
      left: Math.max(slider.scrollLeft - step, 0),
      behavior: 'smooth'
    });
    /*slider.scrollLeft = Math.max(slider.scrollLeft - 200, 0);*/
});